<template>
  <div class="func5">
    <Func5BuscaMedicamentos/>
  </div>
</template>
<script>

import Func5BuscaMedicamentos from '@/views/5/Func5BuscaMedicamentos.vue'

export default {
  name: 'Func5',
  components: { Func5BuscaMedicamentos }
}
</script>
